import PaymentPlanError from './PaymentPlanError';
class PaymentPlanIsNotRegistered extends PaymentPlanError {
    paymentPlanId;
    constructor(paymentPlanId, options) {
        super('Payment plan is not registered', options);
        this.paymentPlanId = paymentPlanId;
    }
}
export default PaymentPlanIsNotRegistered;
